import {
  createContext,
  PropsWithChildren,
  useContext,
  useReducer,
} from "react";

interface RoutingState {
  navLocation: "HOME" | "ABOUT" | "WHITEPAPER" | "ROADMAP" | "CHART" | "DAPP" | "FAQ" | "SOCIAL";
}
const initalState: RoutingState = {
  navLocation: "HOME",
};

const RoutingStateContext = createContext(initalState);
const RoutingDispatchContext = createContext<any>(null);

interface Action {
  type: string;
  payload: any;
}
function reducer(state: RoutingState, action: Action) {
  switch (action.type) {
    case "SWITCH_ROUTE":
      return { ...state, navLocation: action.payload };
  }
}

export default function RoutingProvider({ children }: PropsWithChildren<any>) {
  const [state, dispatch] = useReducer(reducer, initalState as never);

  return (
    <RoutingDispatchContext.Provider value={dispatch}>
      <RoutingStateContext.Provider value={state}>
        {children}
      </RoutingStateContext.Provider>
    </RoutingDispatchContext.Provider>
  );
}

export function useRoutingProviderState() {
  const ctx = useContext(RoutingStateContext);
  return ctx;
}
export function useRoutingProviderDispatch() {
  const ctx = useContext(RoutingDispatchContext);
  return ctx;
}
